module.exports = __webpack_public_path__ + "static/media/road-icon.97486bd0.svg";